import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PermissionItemResponse } from '../../../../../../../api';

@Component({
  selector: 'base-permission-group',
  templateUrl: './base-permission-group.component.html',
})
export class BasePermissionGroupComponent {
  @Input() permissions: Array<PermissionItemResponse & { isSelected: boolean; priority: number }> = [];

  @Output() selectionChange = new EventEmitter<{ permissionId: number; isSelected: boolean }>();

  onPermissionChange(isSelected: boolean, permissionId: number): void {
    this.selectionChange.emit({ permissionId, isSelected });
  }
}
